<div class="header">
  <div class="header-wrapper">
    <img [src]="viewService.conf.logoFull" class="logo">
    <mat-form-field class="no-hint language-select dynamic-width">
      <mat-select [panelClass]="'compact-header-lang'" [ngModel]="languageService.selectedLang" (selectionChange)="languageService.changeLang($event.value, true, authService.isLoggedIn)">
        <mat-option *ngFor="let language of languageService.languages" [value]="language">
          {{language.toUpperCase()}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
